export default "__VITE_ASSET__DS7yoHQ6__"